import { useGetTseLicenseInfoQuery as _useGetTseLicenseInfoQuery } from '../generated/graphql-types';

export const GetTseLicense = () => {
    const { data, error, loading } = _useGetTseLicenseInfoQuery();
    return {
        data: data?.License_getTseLicenseInfo,
        error,
        loading,
    };
};
